import baseApi from './base.api'
import { CONCEPTUAL_LABEL_TYPE_TAG } from './utils/tags'

export const conceptualLabelTypeApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        fetchConceptualLabelTypes: builder.query({
            query: () => ({
                url: '/conceptual-label-types',
                method: 'GET',
            }),
            providesTags: [{ type: CONCEPTUAL_LABEL_TYPE_TAG, id: 'LIST' }],
            
        }),
    }),
})

export const {
    useFetchConceptualLabelTypesQuery,
} = conceptualLabelTypeApi 